import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowGetPatientOrderBlockConfigSchema = z.object({
    orderId: z.string().optional(),
});
export const FlowGetPatientOrderBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.GetPatientOrder),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.PatientOrder),
    config: FlowGetPatientOrderBlockConfigSchema,
});
//# sourceMappingURL=config.js.map